import Footer from "../../component/footer";
import Navbar from "../../component/navbar";

export default function PageBDI() {
  return (
    <div>
      <Navbar />
      <div className="max-w-5xl mx-auto h-screen flex flex-col justify-start items-center py-10 ">
        <div className="w-full px-5 ">
          <div className="relative flex flex-col justify-center items-center">
            <div className="h-full overflow-hidden rounded-xl">
              <img
                src="https://www.cmu.ac.th/content/organization/258b8734-f5db-4af5-8a45-ea3c0124b700/0528361d-c433-4a0b-8316-df162c245f17.jpg"
                className="object-cover w-screen h-full"
                alt=""
              />
            </div>
            <div className="absolute bg-black/80 px-10 py-10 mx-5 rounded-xl">
              <h3 className=" text-[#ffffff] border-b-2 border-[#9e76b4] ">
                หน่วยอาคารและยานพาหนะ
              </h3>
            </div>
          </div>

          <div className=" flex flex-col items-center justify-center text-center md:mt-10 mt-10 pb-[100px]">
            <div className="text-2xl font-bold">หน่วยอาคารและยานพาหนะ</div>
            <div>
              155 หมู่ที่ 5 ตำบล แม่เหียะ อำเภอเมืองเชียงใหม่ เชียงใหม่ 50200
            </div>
            <div>โทร. 053-948050</div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}
